export interface WebResponse {

}

export class ErrorResponse {
  errors: any[];
  type: string;
}

export class ResponseData extends ErrorResponse implements WebResponse {
  total: number;
  items: any[];
}

export class ResponseElementsData extends ErrorResponse implements WebResponse {
  elements: any[];
}